import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { translation } from '@cue/translations';
import { TranslocoPipe } from '@jsverse/transloco';
import { DateFormatPipe, TimeFormatPipe } from '@cue/pipes';
import { LowerCasePipe } from '@angular/common';

@Component({
  selector: 'assist-availability-card',
  templateUrl: './availability-card.component.html',
  styleUrl: './availability-card.component.scss',
  imports: [TranslocoPipe, DateFormatPipe, TimeFormatPipe, LowerCasePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvailabilityCardComponent {
  from = input<Date>();
  to = input<Date>();
  availableState = input.required<'NOW' | 'SOON' | 'UNAVAILABLE'>();

  protected readonly translation = translation;
}
